import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import '../Utility/Normalize.js';
import { SvgWrapper } from '../Utility/SvgWrapper.js';
import '../Utility/UnstyledList.js';

const Mail = forwardRef(function Mail(props, ref) {
    return (jsx(SvgWrapper, Object.assign({ fill: "none", height: "24", viewBox: "0 0 24 24", width: "24" }, props, { ref: ref, children: jsx("path", { clipRule: "evenodd", d: "M2.81445 4.87695H21.377V19.3145H2.81445V4.87695ZM4.87695 6.93945V8.72007L12.0957 12.4798L19.3145 8.72007V6.93945H4.87695ZM19.3145 11.0456L12.0957 14.8053L4.87695 11.0456V17.252H19.3145V11.0456Z", fill: "currentColor", fillRule: "evenodd" }) })));
});

export { Mail as default };
//# sourceMappingURL=Mail.js.map
